module.exports = __webpack_public_path__ + "1a6682378b08212796dab0d469662c29.png";